import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { 
  IFaq, 
  FaqResponse, 
  FaqListResponse 
} from '../models/faq.model';

@Injectable({
  providedIn: 'root'
})
export class FaqService {
  
  constructor(private http: HttpClient) {}

  // Create a new FAQ
  createFaq(faq: IFaq): Observable<FaqResponse> {
    return this.http.post<FaqResponse>(`${environment.apiUrl}/faqs/create`, faq);
  }

  // Get all FAQs
  getAllFaqs(): Observable<FaqListResponse> {
    return this.http.get<FaqListResponse>(`${environment.apiUrl}/faqs/get-all`);
  }

  // Get FAQ by ID
  getFaqById(id: string): Observable<FaqResponse> {
    return this.http.get<FaqResponse>(`${environment.apiUrl}/faqs/${id}`);
  }

  // Update FAQ
  updateFaq(id: string, faq: Partial<IFaq>): Observable<FaqResponse> {
    return this.http.put<FaqResponse>(`${environment.apiUrl}/faqs/${id}`, faq);
  }

  // Delete FAQ
  deleteFaq(id: string): Observable<FaqResponse> {
    return this.http.delete<FaqResponse>(`${environment.apiUrl}/faqs/${id}`);
  }
} 